module.exports = __webpack_public_path__ + "img/lc_map05.32c1be5b.jpg";